import { JSX, useEffect } from "react"

import { useBodyClassName } from "../../Context/BodyClassNameContext"
import {
  constantValueDefinitions,
  constantValueGenerator,
  divisionEquationValueGenerator,
  divisionValueGenerator,
  expressionValueGenerators,
  factorialValueGenerator,
  numberValueGenerator,
  productEquationValueGenerator,
  productValueGenerator,
  randomNumberGenerator,
  subtractionEquationValueGenerator,
  subtractionValueGenerator,
  sumEquationValueGenerator,
  sumValueGenerator,
} from "../../Service"
import { ConstantDefinition } from "../../Service/ValueGenerator/ConstantValueGenerator"
import ValueGeneratorInterface from "../../Service/ValueGenerator/ValueGeneratorInterface"
import ExampleView from "./ExampleView"

import "./demo.css"

export default function DemoPage(): JSX.Element {
  useBodyClassName("demo")
  useEffect((): void => {
    randomNumberGenerator.seed = "1"
  }, [])
  return (
    <>
      <ExampleView
        value={10}
        generator={numberValueGenerator}
        generatorName={numberValueGenerator.constructor.name}
      />
      <ExampleView
        value={10}
        generator={sumValueGenerator}
        generatorName={sumValueGenerator.constructor.name}
      />
      <ExampleView
        value={10}
        generator={sumValueGenerator}
        generatorName={sumValueGenerator.constructor.name}
      />
      <ExampleView
        value={12}
        generator={productValueGenerator}
        generatorName={productValueGenerator.constructor.name}
      />
      <ExampleView
        value={120}
        generator={productValueGenerator}
        generatorName={productValueGenerator.constructor.name}
      />
      <ExampleView
        value={7}
        generator={divisionValueGenerator}
        generatorName={divisionValueGenerator.constructor.name}
      />
      <ExampleView
        value={39}
        generator={subtractionValueGenerator}
        generatorName={subtractionValueGenerator.constructor.name}
      />
      <ExampleView
        value={120}
        generator={factorialValueGenerator}
        generatorName={factorialValueGenerator.constructor.name}
      />
      {constantValueDefinitions.map(
        (definition: ConstantDefinition, key: number): JSX.Element => (
          <ExampleView
            key={key}
            value={definition.range[0]}
            generator={constantValueGenerator}
            generatorName={constantValueGenerator.constructor.name}
          />
        ),
      )}
      <ExampleView
        value={77}
        generator={sumEquationValueGenerator}
        generatorName={sumEquationValueGenerator.constructor.name}
      />
      <ExampleView
        value={77}
        generator={subtractionEquationValueGenerator}
        generatorName={subtractionEquationValueGenerator.constructor.name}
      />
      <ExampleView
        value={77}
        generator={productEquationValueGenerator}
        generatorName={productEquationValueGenerator.constructor.name}
      />
      <ExampleView
        value={77}
        generator={divisionEquationValueGenerator}
        generatorName={divisionEquationValueGenerator.constructor.name}
      />
      {expressionValueGenerators.map(
        (generator: ValueGeneratorInterface, key: number): JSX.Element => (
          <ExampleView
            value={120}
            generator={generator}
            generatorName={generator.constructor.name}
            key={key}
          />
        ),
      )}
    </>
  )
}
